<template>
  <div class="lift-base">
    <v-card
      flat
      tile
    >
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <v-form ref="form">
            <!-- Step 1 -->
            <v-window-item>
              <StepOne :form="lift" />
            </v-window-item>

            <!-- Step 2 -->
            <v-window-item>
              <StepTwo :form="lift" />
            </v-window-item>

            <!-- Step 3 -->
            <v-window-item>
              <StepThree :form="lift" />
            </v-window-item>

            <!-- Step 4 -->
            <v-window-item>
              <StepFour :form="lift" />
            </v-window-item>

            <!-- Step 5 -->
            <v-window-item>
              <StepFive :form="lift" />
            </v-window-item>

            <!-- Step 6 -->
            <v-window-item>
              <StepSix :form="lift" />
            </v-window-item>
          </v-form>
        </v-container>
      </v-window>
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handleProducts from "@/mixins/handleProducts.js";

import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import StepThree from "./components/StepThree";
import StepFour from "./components/StepFour";
import StepFive from "./components/StepFive";
import StepSix from "./components/StepSix";

export default {
  name: "LiftBase",
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix
  },
  mixins: [handleProducts],
  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      // How many steps for this product
      steps: 6,
      onboarding: 0,
      dialog: false,

      // Dropdowns
      dropdowns: {},
      headrestModule: {},
      legSegmentModule: {},
      breastPlateModule: {},

      lift: JSON.parse(JSON.stringify(this.$store.state.lift.lift))
    };
  },
  beforeDestroy() {
    this.$store.dispatch("lift/resetProduct");
  },
  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.lift, this.projectUuid, "LIFT");
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    }
  }
};
</script>
